<template>
    <div>
        <div v-for="module in splitter" class="col s12 m6 l6 xl6">
            <div class="row" v-if="module.type == 'offer'">
                <div class="col s12 m12 l12 xl12 flow-text">
                    <purchase :offer="module"></purchase>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import Purchase from './Purchase'
  import Next from './Next'
  import Email from './Email'

  export default {
    name: 'splitter',
    props: ['splitter'],
    components: {Purchase, Next, Email}
  }
</script>